module.exports = __webpack_public_path__ + "static/media/logo.a43c7073.png";